
    (window.__NEXT_P=window.__NEXT_P||[]).push(["/vendedor", function() {
      var page = require("private-next-pages/vendedor.js")
      if(module.hot) {
        module.hot.accept("private-next-pages/vendedor.js", function() {
          if(!next.router.components["/vendedor"]) return
          var updatedPage = require("private-next-pages/vendedor.js")
          next.router.update("/vendedor", updatedPage.default || updatedPage)
        })
      }
      return { page: page.default || page }
    }]);
  